import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

class Badge extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { children, color, size, classes } = this.props;
        const badgeClass = clsx(
            "lm-badge",
            `lm-badge-${color}`,
            `lm-badge-${size}`,
            classes
        );
        return <div className={badgeClass}>{children}</div>;
    }
}

Badge.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "primary-pastel",
        "danger",
        "danger-pastel",
        "gray",
        "gray-pastel",
        "success-color",
        "amber",
        "navy",
        "orange",
        "error-color",
        "gray-open",
    ]),
    size: PropTypes.oneOf(["s", "m", "l"]),
    classes: PropTypes.string,
};

Badge.defaultProps = {
    color: "primary",
    size: "m",
};

export default Badge;
